
import * as THREE from "../../libs/three.js/build/three.module.js";
import { TextSprite } from "../TextSprite.js";
import { Utils } from "../utils.js";
import { Line2 } from "../../libs/three.js/lines/Line2.js";
import { LineGeometry } from "../../libs/three.js/lines/LineGeometry.js";
import { LineMaterial } from "../../libs/three.js/lines/LineMaterial.js";

function createHeightLine() {
	let lineGeometry = new LineGeometry();

	lineGeometry.setPositions([
		0, 0, 0,
		0, 0, 0,
	]);

	let lineMaterial = new LineMaterial({
		color: 0x00ff00,
		dashSize: 5,
		gapSize: 2,
		linewidth: 2,
		resolution: new THREE.Vector2(1000, 1000),
	});

	lineMaterial.depthTest = false;
	const heightEdge = new Line2(lineGeometry, lineMaterial);
	heightEdge.visible = false;

	//this.add(this.heightEdge);

	return heightEdge;
}

function createHeightLabel() {
	const heightLabel = new TextSprite('');

	heightLabel.setTextColor({ r: 140, g: 250, b: 140, a: 1.0 });
	heightLabel.setBorderColor({ r: 0, g: 0, b: 0, a: 1.0 });
	heightLabel.setBackgroundColor({ r: 0, g: 0, b: 0, a: 1.0 });
	heightLabel.fontsize = 16;
	heightLabel.material.depthTest = false;
	heightLabel.material.opacity = 1;
	heightLabel.visible = false;

	return heightLabel;
}

function createAreaLabel() {
	const areaLabel = new TextSprite('');

	areaLabel.setTextColor({ r: 140, g: 250, b: 140, a: 1.0 });
	areaLabel.setBorderColor({ r: 0, g: 0, b: 0, a: 1.0 });
	areaLabel.setBackgroundColor({ r: 0, g: 0, b: 0, a: 1.0 });
	areaLabel.fontsize = 16;
	areaLabel.material.depthTest = false;
	areaLabel.material.opacity = 1;
	areaLabel.visible = false;

	return areaLabel;
}

function createCircleRadiusLabel() {
	const circleRadiusLabel = new TextSprite("");

	circleRadiusLabel.setTextColor({ r: 140, g: 250, b: 140, a: 1.0 });
	circleRadiusLabel.setBorderColor({ r: 0, g: 0, b: 0, a: 1.0 });
	circleRadiusLabel.setBackgroundColor({ r: 0, g: 0, b: 0, a: 1.0 });
	circleRadiusLabel.fontsize = 16;
	circleRadiusLabel.material.depthTest = false;
	circleRadiusLabel.material.opacity = 1;
	circleRadiusLabel.visible = false;

	return circleRadiusLabel;
}

function createCircleRadiusLine() {
	const lineGeometry = new LineGeometry();

	lineGeometry.setPositions([
		0, 0, 0,
		0, 0, 0,
	]);

	const lineMaterial = new LineMaterial({
		color: 0xff0000,
		linewidth: 2,
		resolution: new THREE.Vector2(1000, 1000),
		gapSize: 1,
		dashed: true,
	});

	lineMaterial.depthTest = false;

	const circleRadiusLine = new Line2(lineGeometry, lineMaterial);
	circleRadiusLine.visible = false;

	return circleRadiusLine;
}

function createCircleLine() {
	const coordinates = [];

	let n = 128;
	for (let i = 0; i <= n; i++) {
		let u0 = 2 * Math.PI * (i / n);
		let u1 = 2 * Math.PI * (i + 1) / n;

		let p0 = new THREE.Vector3(
			Math.cos(u0),
			Math.sin(u0),
			0
		);

		let p1 = new THREE.Vector3(
			Math.cos(u1),
			Math.sin(u1),
			0
		);

		coordinates.push(
			...p0.toArray(),
			...p1.toArray(),
		);
	}

	const geometry = new LineGeometry();
	geometry.setPositions(coordinates);

	const material = new LineMaterial({
		color: 0xff0000,
		dashSize: 5,
		gapSize: 2,
		linewidth: 2,
		resolution: new THREE.Vector2(1000, 1000),
	});

	material.depthTest = false;

	const circleLine = new Line2(geometry, material);
	circleLine.visible = false;
	circleLine.computeLineDistances();

	return circleLine;
}

function createCircleCenter() {
	const sg = new THREE.SphereGeometry(1, 32, 32);
	const sm = new THREE.MeshNormalMaterial();

	const circleCenter = new THREE.Mesh(sg, sm);
	circleCenter.visible = false;

	return circleCenter;
}

function createLine() {
	const geometry = new LineGeometry();

	geometry.setPositions([
		0, 0, 0,
		0, 0, 0,
	]);

	const material = new LineMaterial({
		color: 0xff0000,
		linewidth: 2,
		resolution: new THREE.Vector2(1000, 1000),
		gapSize: 1,
		dashed: true,
	});

	material.depthTest = false;

	const line = new Line2(geometry, material);

	return line;
}

function createCircle() {

	const coordinates = [];

	let n = 128;
	for (let i = 0; i <= n; i++) {
		let u0 = 2 * Math.PI * (i / n);
		let u1 = 2 * Math.PI * (i + 1) / n;

		let p0 = new THREE.Vector3(
			Math.cos(u0),
			Math.sin(u0),
			0
		);

		let p1 = new THREE.Vector3(
			Math.cos(u1),
			Math.sin(u1),
			0
		);

		coordinates.push(
			...p0.toArray(),
			...p1.toArray(),
		);
	}

	const geometry = new LineGeometry();
	geometry.setPositions(coordinates);

	const material = new LineMaterial({
		color: 0xff0000,
		dashSize: 5,
		gapSize: 2,
		linewidth: 2,
		resolution: new THREE.Vector2(1000, 1000),
	});

	material.depthTest = false;

	const line = new Line2(geometry, material);
	line.computeLineDistances();

	return line;

}

function createAzimuth() {

	const azimuth = {
		label: null,
		center: null,
		target: null,
		north: null,
		centerToNorth: null,
		centerToTarget: null,
		centerToTargetground: null,
		targetgroundToTarget: null,
		circle: null,

		node: null,
	};

	const sg = new THREE.SphereGeometry(1, 32, 32);
	const sm = new THREE.MeshNormalMaterial();

	{
		const label = new TextSprite("");

		label.setTextColor({ r: 140, g: 250, b: 140, a: 1.0 });
		label.setBorderColor({ r: 0, g: 0, b: 0, a: 1.0 });
		label.setBackgroundColor({ r: 0, g: 0, b: 0, a: 1.0 });
		label.fontsize = 16;
		label.material.depthTest = false;
		label.material.opacity = 1;

		azimuth.label = label;
	}

	azimuth.center = new THREE.Mesh(sg, sm);
	azimuth.target = new THREE.Mesh(sg, sm);
	azimuth.north = new THREE.Mesh(sg, sm);
	azimuth.centerToNorth = createLine();
	azimuth.centerToTarget = createLine();
	azimuth.centerToTargetground = createLine();
	azimuth.targetgroundToTarget = createLine();
	azimuth.circle = createCircle();

	azimuth.node = new THREE.Object3D();
	azimuth.node.add(
		azimuth.centerToNorth,
		azimuth.centerToTarget,
		azimuth.centerToTargetground,
		azimuth.targetgroundToTarget,
		azimuth.circle,
		azimuth.label,
		azimuth.center,
		azimuth.target,
		azimuth.north,
	);

	return azimuth;
}

export class Measure extends THREE.Object3D {
	constructor() {
		super();
		this.viewer = viewer;
		this.apiBaseUrl = 'https://api.infraestructuradigital.es';
		this.authToken = null;
		this.constructor.counter = (this.constructor.counter === undefined) ? 0 : this.constructor.counter + 1;

		//Temporal
		//this.idInspeccion = 7;

		this.name = 'Measure_' + this.constructor.counter;
		this.isGeotag = false;
		this.points = [];
		this._showDistances = true;
		this._showCoordinates = false;
		this._showArea = false;
		this._closed = true;
		this._showAngles = false;
		this._showCircle = false;
		this._showHeight = false;
		this._showEdges = true;
		this._showAzimuth = false;
		this.maxMarkers = Number.MAX_SAFE_INTEGER;

		this.sphereGeometry = new SphereGeometry(0.4, 10, 10);
		this.color = new Color(0xff0000);

		this.geotags = [];
		this.spheres = [];
		this.edges = [];
		this.sphereLabels = [];
		this.edgeLabels = [];
		this.angleLabels = [];
		this.coordinateLabels = [];

		this.heightEdge = createHeightLine();
		this.heightLabel = createHeightLabel();
		this.areaLabel = createAreaLabel();
		this.circleRadiusLabel = createCircleRadiusLabel();
		this.circleRadiusLine = createCircleRadiusLine();
		this.circleLine = createCircleLine();
		this.circleCenter = createCircleCenter();

		this.azimuth = createAzimuth();

		this.add(this.heightEdge);
		this.add(this.heightLabel);
		this.add(this.areaLabel);
		this.add(this.circleRadiusLabel);
		this.add(this.circleRadiusLine);
		this.add(this.circleLine);
		this.add(this.circleCenter);

		this.add(this.azimuth.node);

	}

	createSphereMaterial() {
		let sphereMaterial = new MeshLambertMaterial({
			//shading: THREE.SmoothShading,
			color: this.color,
			depthTest: false,
			depthWrite: false
		}
		);

		return sphereMaterial;
	};


	addGeotag(point) {
		console.log("addGeotag called with point:", point);
		if (point instanceof Vector3) {
			point = { position: point };
		} else if (point instanceof Array) {
			point = { position: new Vector3(...point) };
		}
		this.points.push(point);

		//Crear un marcador
		let sphere = new Mesh(this.sphereGeometry, this.createSphereMaterial());
		sphere.position.copy(point.position);
		sphere.userData.point = point; // Añadir datos de usuario a la esfera
		console.log(sphere.userData.point);
		this.add(sphere);
		this.spheres.push(sphere);

		console.log("Sphere created and added to the scene at position:", point.position);

		//Evento para mostrar la interfaz al hacer clic en el punto
		this.viewer.inputHandler.registerInteractiveObject(sphere);
		// Crear etiqueta de borde
		let edgeLabel = new TextSprite();
		edgeLabel.setBorderColor({ r: 0, g: 0, b: 0, a: 1.0 });
		edgeLabel.setBackgroundColor({ r: 0, g: 0, b: 0, a: 1.0 });
		edgeLabel.material.depthTest = false;
		edgeLabel.visible = false;
		edgeLabel.fontsize = 16;
		this.edgeLabels.push(edgeLabel);
		this.add(edgeLabel);

		console.log("1Etiqueta de borde creada:", edgeLabel.visible);

		// Crear etiqueta de ángulo
		let angleLabel = new TextSprite();
		angleLabel.setBorderColor({ r: 0, g: 0, b: 0, a: 1.0 });
		angleLabel.setBackgroundColor({ r: 0, g: 0, b: 0, a: 1.0 });
		angleLabel.fontsize = 16;
		angleLabel.material.depthTest = false;
		angleLabel.material.opacity = 1;
		angleLabel.visible = false;
		this.angleLabels.push(angleLabel);
		this.add(angleLabel);

		console.log('Etiquetas de bordes:', this.edgeLabels);
		this.createGeotagDetailsForm(point);
	}


	
	//Crear la interfaz de usuario para agregar detalles del punto
	createGeotagDetailsForm(point) {
		console.log("Creating geotag details form for point:", point);
		const existingForm = document.getElementById('geotagForm');
		if (existingForm) {
			existingForm.remove();
		}
		const existingList = document.getElementById('geotagList');
		if (existingList) {
			existingList.remove();
		}

		// Crear contenedor del formulario
		const formContainer = document.createElement('div');
		formContainer.id = 'geotagForm';
		formContainer.style.position = 'fixed';
		formContainer.style.top = '10px';
		formContainer.style.right = '10px';
		formContainer.style.padding = '15px';
		formContainer.style.backgroundColor = '#1a237e'; // Azul oscuro
		formContainer.style.color = 'white';
		formContainer.style.border = '1px solid #1a237e';
		formContainer.style.zIndex = '1000';
		formContainer.style.borderRadius = '8px';
		formContainer.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.1)';
		formContainer.style.maxWidth = '300px';
		formContainer.style.minWidth = '250px';
		formContainer.style.height = 'auto';
		formContainer.style.overflowY = 'auto';
		formContainer.style.fontSize = '14px';

		console.log("Form container created:", formContainer);

		// Botones de "Atrás" y "Cerrar" arriba
		const controlsContainer = document.createElement('div');
		controlsContainer.style.display = 'flex';
		controlsContainer.style.justifyContent = 'space-between';
		controlsContainer.style.marginBottom = '10px';

		const backButton = document.createElement('button');
		backButton.innerHTML = '&#x2190;'; // Flecha hacia atrás
		backButton.style.backgroundColor = 'transparent';
		backButton.style.color = 'white';
		backButton.style.border = 'none';
		backButton.style.fontSize = '20px';
		backButton.style.cursor = 'pointer';
		backButton.addEventListener('click', () => {
			const geotags = [
				{ id: 1, gravedad: 'Alta', nombre: 'Geotag 1' },
				{ id: 2, gravedad: 'Media', nombre: 'Geotag 2' },
				{ id: 3, gravedad: 'Baja', nombre: 'Geotag 3' },
			];
			console.log("atras");

			this.createGeotagList(geotags); // Llama a la función para crear el listado
		});

		const closeButton = document.createElement('button');
		closeButton.textContent = '×'; // Símbolo de cerrar
		closeButton.style.backgroundColor = 'transparent';
		closeButton.style.color = 'white';
		closeButton.style.border = 'none';
		closeButton.style.fontSize = '20px';
		closeButton.style.cursor = 'pointer';
		closeButton.addEventListener('click', () => {
			console.log('Cerrando el formulario...');
			document.getElementById('geotagForm').remove();
		});

		controlsContainer.appendChild(backButton);
		controlsContainer.appendChild(closeButton);
		formContainer.appendChild(controlsContainer);

		// Título del formulario
		const title = document.createElement('h3');
		title.textContent = 'Geotag Details';
		title.style.color = '#ffffff';
		title.style.fontSize = '16px';
		title.style.textAlign = 'center';
		formContainer.appendChild(title);

		// Función para crear un campo desplegable
		const createDropdown = (labelText, options, id) => {
			const formGroup = document.createElement('div');
			formGroup.className = 'form-group';

			const label = document.createElement('label');
			label.textContent = labelText;
			label.style.color = '#ffffff';
			label.style.fontSize = '14px';
			formGroup.appendChild(label);

			const select = document.createElement('select');
			select.id = id;
			select.style.backgroundColor = '#333';
			select.style.color = 'white';
			select.style.width = '100%';
			select.style.marginBottom = '10px';
			select.style.height = '30px';

			options.forEach(option => {
				const opt = document.createElement('option');
				opt.value = option;
				opt.textContent = option;
				select.appendChild(opt);
			});

			formGroup.appendChild(select);
			return formGroup;
		};

		// Campos desplegables
		formContainer.appendChild(createDropdown("Tipo", [
			"Degradación de tramo no revestido",
			"Fallo bulones / anclajes",
			"Despegue - Desprendimiento del revestimiento",
			"Fisuras - Grietas",
			"Deformaciones",
			"Movimientos entre piezas de revestimiento de hormigón prefabricado",
			"Degradación de elementos metálicos del revestimiento (excluidas armaduras en elementos de hormigón)",
			"Degradación de armaduras de hormigón",
			"Degradación de revestimiento de hormigón - En elementos superiores, laterales y especiales",
			"Degradación de revestimiento de hormigón - En elementos inferiores",
			"Degradación de revestimiento de fábrica (ladrillo / mampostería / sillería)",
			"Oquedades en trasdós",
			"Descalce de plataforma / placa",
			"Humedades - Filtraciones",
			"Deficiencias sistema de impermeabilización y/o drenaje del revestimiento (lámina interna/externa, mechinales)",
			"Presencia de agua en plataforma",
			"Contaminación de balasto",
			"Vegetación herbácea, musgos y líquenes",
			"Vegetación arbórea",
			"Grafitis / Pintadas",
			"Deterioro material de vía",
			"Deterioro de la integridad estructural del refugio",
			"Deterioro de la operatividad del refugio",
			"Deterioro instalación (de electrificación/señalización/protección y seguridad/instalación de vía)",
			"Deterioro canalización de instalaciones (no se evalúa funcionamiento de equipos)",
			"Deficiencias sistema de drenaje (excluidos mechinales y láminas internas/externas)",
			"Deficiencias del sistema de acceso desde el exterior",
			"Deficiencias en el punto de evacuación y rescate"
		], "tipo"));

		formContainer.appendChild(createDropdown("Elemento", [
			"Embocadura Frontal",
			"Embocadura Lateral",
			"Embocadura Interior",
			"Tramo Interior Parte Superior",
			"Tramo Interior Lateral",
			"Tramo Interior Parte Inferior",
			"Tramo Interior Elementos Especiales",
			"Refugios",
			"Pasillos de Evacuación",
			"Acceso a Galería/pozo/sala Tecnica/exterior/tubo Plataforma Ferroviaria",
			"Canalización De Instalaciones",
			"ODLS - Obras de drenaje longitudinal superficial",
			"ODLP - Obras de drenaje longitudinal profundo",
			"ODT - Obras de drenaje transversal",
			"ODV - Obras de drenaje vertical",
			"ODP - Obras de drenaje puntual",
			"Cruce de Vías",
			"Galería de Conexión Transversal",
			"Galería Longitudinal Auxiliar",
			"Salidas al Exterior",
			"Otros",
			"Pozo de Evacuación",
			"Pozo de Bombeo",
			"Pozo de Ventilación",
			"Acceso desde el Exterior",
			"Sala Técnica",
			"Punto de Evacuación y Rescate",
			"Estación Subterránea (Infraestructura Ferroviaria - No Estación)",
			"Depuradoras, Depósitos Y Decantadores (Infraestructura - No Funcionalidad)",
			"Alumbrado Permanente",
			"Electrificación",
			"Señalización",
			"Protección y Seguridad",
			"Vía y Balasto"
		], "elemento"));

		formContainer.appendChild(createDropdown("Intensidad", ["Alta", "Media", "Baja"], "intensidad"));
		formContainer.appendChild(createDropdown("Evolución", ["Rápida", "Lenta", "Estable"], "evolucion"));

		// Campo deshabilitado: Categoría y Gravedad
		["Categoría", "Gravedad"].forEach(field => {
			const formGroup = document.createElement('div');
			formGroup.className = 'form-group';

			const label = document.createElement('label');
			label.textContent = field;
			label.style.color = '#ffffff';
			label.style.fontSize = '14px';
			formGroup.appendChild(label);

			const input = document.createElement('input');
			input.type = 'text';
			input.id = field.toLowerCase();
			input.style.backgroundColor = '#333';
			input.style.color = 'white';
			input.style.width = '100%';
			input.style.marginBottom = '10px';
			input.style.height = '25px';
			input.disabled = true;

			formGroup.appendChild(input);
			formContainer.appendChild(formGroup);
		});

		// Campo de Comentarios
		const commentGroup = document.createElement('div');
		const commentLabel = document.createElement('label');
		commentLabel.textContent = 'Comentario';
		commentLabel.style.color = '#ffffff';
		commentGroup.appendChild(commentLabel);

		const commentInput = document.createElement('textarea');
		commentInput.id = 'comentario';
		commentInput.style.backgroundColor = '#333';
		commentInput.style.color = 'white';
		commentInput.style.width = '100%';
		commentInput.style.marginBottom = '10px';

		commentGroup.appendChild(commentLabel);
		commentGroup.appendChild(commentInput);
		formContainer.appendChild(commentGroup);

		// Campo combinado para Tamaño (Cantidad y Unidades)
		const sizeGroup = document.createElement('div');
		sizeGroup.style.display = 'flex';
		sizeGroup.style.alignItems = 'center';
		sizeGroup.style.marginBottom = '10px';

		const quantityInput = document.createElement('input');
		quantityInput.type = 'text';
		quantityInput.id = 'cantidad';
		quantityInput.style.backgroundColor = '#333';
		quantityInput.style.color = 'white';
		quantityInput.style.flex = '1';
		quantityInput.style.marginRight = '5px';
		quantityInput.placeholder = 'Cantidad';

		const unitsSelect = document.createElement('select');
		unitsSelect.id = 'unidades';
		unitsSelect.style.backgroundColor = '#333';
		unitsSelect.style.color = 'white';
		unitsSelect.style.flex = '1';

		["m", "m²"].forEach(unit => {
			const opt = document.createElement('option');
			opt.value = unit;
			opt.textContent = unit;
			unitsSelect.appendChild(opt);
		});

		sizeGroup.appendChild(quantityInput);
		sizeGroup.appendChild(unitsSelect);

		const sizeLabel = document.createElement('label');
		sizeLabel.textContent = 'Tamaño';
		sizeLabel.style.color = '#ffffff';
		sizeLabel.style.fontSize = '14px';
		formContainer.appendChild(sizeLabel);
		formContainer.appendChild(sizeGroup);

		// Campo combinado para X, Y, Z
		const xyzGroup = document.createElement('div');
		xyzGroup.className = 'form-group';

		const xyzLabel = document.createElement('label');
		xyzLabel.textContent = 'Posición (X, Y, Z)';
		xyzLabel.style.color = '#ffffff';
		xyzLabel.style.fontSize = '14px';
		xyzGroup.appendChild(xyzLabel);

		const xyzInput = document.createElement('input');
		xyzInput.type = 'text';
		xyzInput.id = 'xyz';
		xyzInput.style.backgroundColor = '#333';
		xyzInput.style.color = 'white';
		xyzInput.style.width = '100%';
		xyzInput.style.marginBottom = '10px';
		xyzInput.style.height = '25px';
		xyzInput.value = `${point.position.x.toFixed(2)}, ${point.position.y.toFixed(2)}, ${point.position.z.toFixed(2)}`;
		xyzInput.disabled = true;

		xyzGroup.appendChild(xyzInput);
		formContainer.appendChild(xyzGroup);

		// Botones Save y Cancelar
		const actionsContainer = document.createElement('div');
		actionsContainer.style.display = 'flex';
		actionsContainer.style.justifyContent = 'space-between';
		actionsContainer.style.marginTop = '10px';

		const saveButton = document.createElement('button');
		saveButton.textContent = 'Save';
		saveButton.style.backgroundColor = '#333';
		saveButton.style.color = '#ffffff';
		saveButton.style.border = '1px solid #ffffff';
		saveButton.style.padding = '5px 10px';
		saveButton.style.borderRadius = '4px';
		saveButton.style.cursor = 'pointer';

		const cancelButton = document.createElement('button');
		cancelButton.textContent = 'Cancelar';
		cancelButton.style.backgroundColor = '#333';
		cancelButton.style.color = '#ffffff';
		cancelButton.style.border = '1px solid #ffffff';
		cancelButton.style.padding = '5px 10px';
		cancelButton.style.borderRadius = '4px';
		cancelButton.style.cursor = 'pointer';

		actionsContainer.appendChild(saveButton);
		actionsContainer.appendChild(cancelButton);
		formContainer.appendChild(actionsContainer);

		document.body.appendChild(formContainer);
		console.log("Formulario creado.");
	}


	
	createGeotagList(geotags) {
		console.log("Creando listado de geotags...", geotags);
	
		// Cerrar cualquier interfaz existente
		const existingList = document.getElementById('geotagList');
		if (existingList) {
			console.log("Eliminando listado existente...");
			existingList.remove();
		}
		const existingForm = document.getElementById('geotagForm');
		if (existingForm) {
			console.log("Eliminando formulario existente...");
			existingForm.remove();
		}
	
		// Crear el contenedor del listado
		const geotagListContainer = document.createElement('div');
		geotagListContainer.id = 'geotagList';
		geotagListContainer.style.position = 'fixed';
		geotagListContainer.style.top = '10px';
		geotagListContainer.style.right = '10px';
		geotagListContainer.style.padding = '15px';
		geotagListContainer.style.backgroundColor = '#1a237e'; // Azul oscuro
		geotagListContainer.style.color = 'white';
		geotagListContainer.style.border = '1px solid #1a237e';
		geotagListContainer.style.borderRadius = '8px';
		geotagListContainer.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.1)';
		geotagListContainer.style.maxWidth = '300px';
		geotagListContainer.style.minWidth = '250px';
		geotagListContainer.style.height = 'auto';
		geotagListContainer.style.overflowY = 'auto';
		geotagListContainer.style.fontSize = '14px';
		geotagListContainer.style.zIndex = '9999'; // Asegurarse de que esté sobre otros elementos
	
		console.log("Contenedor del listado creado:", geotagListContainer);
	
		// Título del listado
		const title = document.createElement('h3');
		title.textContent = 'Listado de Geotags';
		title.style.color = '#ffffff';
		title.style.textAlign = 'center';
		geotagListContainer.appendChild(title);
	
		// Crear cada elemento del listado
		geotags.forEach(geotag => {
			const geotagItem = document.createElement('div');
			geotagItem.style.display = 'flex';
			geotagItem.style.justifyContent = 'space-between';
			geotagItem.style.alignItems = 'center';
			geotagItem.style.padding = '10px';
			geotagItem.style.borderBottom = '1px solid rgba(255, 255, 255, 0.2)';
			geotagItem.style.cursor = 'pointer';
	
			const idLabel = document.createElement('span');
			idLabel.textContent = `ID: ${geotag.id} - ${geotag.nombre}`;
			idLabel.style.color = '#ffffff';
	
			const gravityCircle = document.createElement('div');
			gravityCircle.style.width = '15px';
			gravityCircle.style.height = '15px';
			gravityCircle.style.borderRadius = '50%';
			gravityCircle.style.marginLeft = '10px';
			gravityCircle.style.backgroundColor =
				geotag.gravedad === 'Alta' ? 'red' :
				geotag.gravedad === 'Media' ? 'orange' :
				'green';
	
			geotagItem.appendChild(idLabel);
			geotagItem.appendChild(gravityCircle);
	
			// Evento de clic para abrir el formulario del geotag
			geotagItem.addEventListener('click', () => {
				console.log(`Seleccionando Geotag ID: ${geotag.id}`);
				this.createGeotagDetailsForm(geotag); // Abrir el formulario con los datos
			});
	
			geotagListContainer.appendChild(geotagItem);
		});
	
		// Añadir el listado al DOM
		document.body.appendChild(geotagListContainer);
	
		console.log("Listado de geotags añadido al DOM.");
	}

	async saveGeotag(geotagData) {
		if (!this.authToken) {
			console.error('No se ha encontrado token de autenticacion. Sin log in');
			return false;
		}
		try {
			const response = await fetch(`${this.apiBaseUrl}/geotag`, {
				method: 'get',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${this.authToken}`, // Incluir el token en la cabecera
				},
				body: JSON.stringify(geotagData),
			});
			if (response.ok) {
				console.log('Geotag successfully saved:', await response.json());
				return true;
			} else {
				console.error('Error saving geotag:', response.status, await response.text());
				return false;
			}
		} catch (error) {
			console.error('Failed to send geotag:', error);
			return false;
		}
	}

	/*	async loadGeotagsFromAPI(idInspeccion, authToken) {
			try {
				const response = await fetch(`${this.apiBaseUrl}/damages/inspeccion/${idInspeccion}`, {
					method: 'GET',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${authToken}`, // Incluir el Bearer Token
					},
				});
		
				if (!response.ok) {
					throw new Error(`Error al cargar geotags: ${response.status} ${response.statusText}`);
				}
		
				const data = await response.json();
				this.geotags = data;
		
				data.forEach(geotag => {
					console.log("dentroForEach");
					console.log(geotag); // Reemplazar con lógica para añadir los geotags a nube llamar a addgeotag con lista de geotags
					// this.addGeotag(geotag);
				});
				console.log('Geotags cargados correctamente:', this.geotags);
			} catch (error) {
				console.error('Error al cargar geotags:', error); // Registra el error completo
			}
		}*/

	loadGeotagsFromAPI(idInspeccion) {
		console.log("in load", this.authToken);
		return new Promise((resolve, reject) => {
			const xhr = new XMLHttpRequest();
			const url = `${this.apiBaseUrl}/damages/inspeccion/${idInspeccion}`;

			xhr.open('GET', url, true);
			xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
			xhr.setRequestHeader('Authorization', `Bearer ${this.authToken}`); // Agregar el Bearer Token

			xhr.onload = function () {
				if (xhr.status >= 200 && xhr.status < 300) {

					try {
						const data = JSON.parse(xhr.responseText); // Parsear la respuesta como JSON
						resolve(data); // Resolver la promesa con los datos
					} catch (error) {
						reject(new Error(`Error al parsear la respuesta: ${error.message}`));
					}
				} else {
					reject(new Error(`Error al cargar geotags: ${xhr.status} ${xhr.statusText}`));
				}
			};

			xhr.onerror = function () {
				reject(new Error('Error de red o conexión'));
			};

			xhr.send(); // Enviar la solicitud
		}).then(data => {
			this.geotags = data;
			data.forEach(geotag => {
				console.log(geotag);
				console.log("dentroForEach");
				// Llamar a addGeotag si es necesario
				this.positionGeotag(geotag);
			});
			this.edgeLabels[1].visible = false;

			console.log('Geotags cargados correctamente:', this.geotags);
			this.viewer.inputHandler.update();
		}).catch(error => {
			console.error('Error al cargar geotags:', error);
		});
	}

	positionGeotag(geotag) {
		console.log("dentro de positionGeotag:", geotag);

		if (!geotag.CoordenadaX || !geotag.CoordenadaY || !geotag.CoordenadaZ) {
			console.error("Coordenadas no válidas para geotag:", geotag);
			return;
		}

		const point = {
			position: new Vector3(
				parseFloat(geotag.CoordenadaX),
				parseFloat(geotag.CoordenadaY),
				parseFloat(geotag.CoordenadaZ)
			)
		};
		console.log("addGeotag called with point:", point);
		if (point instanceof Vector3) {
			point = { position: point };
		} else if (point instanceof Array) {
			point = { position: new Vector3(...point) };
		}
		this.points.push(point);
		//Crear un marcador
		let sphere = new Mesh(this.sphereGeometry, this.createSphereMaterial());
		sphere.position.copy(point.position);
		sphere.userData.point = point; // Añadir datos de usuario a la esfera
		console.log("datosUsuario", sphere.userData.point);
		this.add(sphere);
		this.spheres.push(sphere);
		console.log("Sphere created and added to the scene at position:", point);
		//Evento para mostrar la interfaz al hacer clic en el punto
		this.viewer.inputHandler.registerInteractiveObject(sphere);
		console.log("Geometry:", this.sphereGeometry);
		console.log("Material:", this.createSphereMaterial());
		console.log("Objetos interactivos registrados:", this.viewer.inputHandler.interactiveObjects);


		{ // Event Listeners
			let drag = (e) => {
				console.log('drag');
				let I = Utils.getMousePointCloudIntersection(
					e.drag.end,
					e.viewer.scene.getActiveCamera(),
					e.viewer,
					e.viewer.scene.pointclouds,
					{ pickClipped: true });

				if (I) {
					let i = this.spheres.indexOf(e.drag.object);
					if (i !== -1) {
						let point = this.points[i];

						// loop through current keys and cleanup ones that will be orphaned
						for (let key of Object.keys(point)) {
							if (!I.point[key]) {
								delete point[key];
							}
						}

						for (let key of Object.keys(I.point).filter(e => e !== 'position')) {
							point[key] = I.point[key];
						}

						this.setPosition(i, I.location);
					}
				}
			};

			let drop = e => {
				console.log('drop');
				let i = this.spheres.indexOf(e.drag.object);
				if (i !== -1) {
					this.dispatchEvent({
						'type': 'marker_dropped',
						'measurement': this,
						'index': i
					});
				}
			};

			let mouseover = (e) => {
				console.log('mouseover');
				e.object.material.emissive.setHex(0x888888);

			};
			let mouseleave = (e) => {
				console.log('mouuseleave');
				e.object.material.emissive.setHex(0x000000);

			};
			/*let click = (e) => {
					console.log("click");
					//this.updateGeotagDetailsForm(e.object.position);
					e.object.material.emissive.setHex(0x000000);

					
					}*/

			sphere.addEventListener('drag', drag);
			sphere.addEventListener('drop', drop);
			sphere.addEventListener('mouseover', mouseover);
			sphere.addEventListener('mouseleave', mouseleave);
			//sphere.addEventListener('click', click);
		}


		let edgeLabel = new TextSprite();
		edgeLabel.setBorderColor({ r: 0, g: 0, b: 0, a: 1.0 });
		edgeLabel.setBackgroundColor({ r: 0, g: 0, b: 0, a: 1.0 });
		edgeLabel.material.depthTest = false;
		edgeLabel.visible = false;
		edgeLabel.fontsize = 16;
		this.edgeLabels.push(edgeLabel);
		this.add(edgeLabel);

		console.log("2Etiqueta de borde creada:", edgeLabel.visible);

		// Crear etiqueta de ángulo
		let angleLabel = new TextSprite();
		angleLabel.setBorderColor({ r: 0, g: 0, b: 0, a: 1.0 });
		angleLabel.setBackgroundColor({ r: 0, g: 0, b: 0, a: 1.0 });
		angleLabel.fontsize = 16;
		angleLabel.material.depthTest = false;
		angleLabel.material.opacity = 1;
		angleLabel.visible = false;
		this.angleLabels.push(angleLabel);
		this.add(angleLabel);
		console.log('2Etiquetas de bordes:', this.edgeLabels);





	}

	loadSpecificGeotag(idGeotag) {


	}



	updateGeotagDetailsForm(point) {
		console.log("Updating geotag details form for point:", point);

		// Obtener el formulario existente
		let formContainer = document.getElementById('geotagForm');
		if (!formContainer) {
			console.log("Form container does not exist. Creating new form.");
			this.createGeotagDetailsForm(point);
			return;
		}

		// Actualizar los campos con los datos del punto
		document.getElementById('x').value = point.position.x.toFixed(2);
		document.getElementById('y').value = point.position.y.toFixed(2);
		document.getElementById('z').value = point.position.z.toFixed(2);

		console.log("Geotag details form updated with coordinates:", point.position.x, point.position.y, point.position.z);
	}




	addMarker(point) {
		if (point.x != null) {
			point = { position: point };
		} else if (point instanceof Array) {
			point = { position: new Vector3(...point) };
		}
		this.points.push(point);

		// sphere
		let sphere = new Mesh(this.sphereGeometry, this.createSphereMaterial());

		this.add(sphere);
		this.spheres.push(sphere);

		{ // edges
			let lineGeometry = new LineGeometry();
			lineGeometry.setPositions([
				0, 0, 0,
				0, 0, 0,
			]);

			let lineMaterial = new LineMaterial({
				color: 0xff0000,
				linewidth: 2,
				resolution: new Vector2(1000, 1000),
			});

			lineMaterial.depthTest = false;

			let edge = new Line2(lineGeometry, lineMaterial);
			edge.visible = true;

			this.add(edge);
			this.edges.push(edge);
		}

		{ // edge labels
			let edgeLabel = new TextSprite();
			edgeLabel.setBorderColor({ r: 0, g: 0, b: 0, a: 1.0 });
			edgeLabel.setBackgroundColor({ r: 0, g: 0, b: 0, a: 1.0 });
			edgeLabel.material.depthTest = false;
			edgeLabel.visible = false;
			edgeLabel.fontsize = 16;
			this.edgeLabels.push(edgeLabel);
			this.add(edgeLabel);
		}

		{ // angle labels
			let angleLabel = new TextSprite();
			angleLabel.setBorderColor({ r: 0, g: 0, b: 0, a: 1.0 });
			angleLabel.setBackgroundColor({ r: 0, g: 0, b: 0, a: 1.0 });
			angleLabel.fontsize = 16;
			angleLabel.material.depthTest = false;
			angleLabel.material.opacity = 1;
			angleLabel.visible = false;
			this.angleLabels.push(angleLabel);
			this.add(angleLabel);
		}

		{ // coordinate labels
			let coordinateLabel = new TextSprite();
			coordinateLabel.setBorderColor({ r: 0, g: 0, b: 0, a: 1.0 });
			coordinateLabel.setBackgroundColor({ r: 0, g: 0, b: 0, a: 1.0 });
			coordinateLabel.fontsize = 16;
			coordinateLabel.material.depthTest = false;
			coordinateLabel.material.opacity = 1;
			coordinateLabel.visible = false;
			this.coordinateLabels.push(coordinateLabel);
			this.add(coordinateLabel);
		}

		{ // Event Listeners
			let drag = (e) => {
				console.log('drag');
				let I = Utils.getMousePointCloudIntersection(
					e.drag.end,
					e.viewer.scene.getActiveCamera(),
					e.viewer,
					e.viewer.scene.pointclouds,
					{ pickClipped: true });

				if (I) {
					let i = this.spheres.indexOf(e.drag.object);
					if (i !== -1) {
						let point = this.points[i];

						// loop through current keys and cleanup ones that will be orphaned
						for (let key of Object.keys(point)) {
							if (!I.point[key]) {
								delete point[key];
							}
						}

						for (let key of Object.keys(I.point).filter(e => e !== 'position')) {
							point[key] = I.point[key];
						}

						this.setPosition(i, I.location);
					}
				}
			};

			let drop = e => {
				console.log('drop');
				let i = this.spheres.indexOf(e.drag.object);
				if (i !== -1) {
					this.dispatchEvent({
						'type': 'marker_dropped',
						'measurement': this,
						'index': i
					});
				}
			};

			let mouseover = (e) => {
				console.log('mouseover');
				e.object.material.emissive.setHex(0x888888);

			};
			let mouseleave = (e) => {
				console.log('mouuseleave');
				e.object.material.emissive.setHex(0x000000);

			};
			/** 	let click = (e) => {
					console.log("click");
					this.updateGeotagDetailsForm(e.object.position);
					
					}*/

			sphere.addEventListener('drag', drag);
			sphere.addEventListener('drop', drop);
			sphere.addEventListener('mouseover', mouseover);
			sphere.addEventListener('mouseleave', mouseleave);
			//sphere.addEventListener('click', click);
		}

		let event = {
			type: 'marker_added',
			measurement: this,
			sphere: sphere
		};
		this.dispatchEvent(event);

		this.setMarker(this.points.length - 1, point);
	};

	removeMarker(index) {
		this.points.splice(index, 1);

		this.remove(this.spheres[index]);

		let edgeIndex = (index === 0) ? 0 : (index - 1);
		this.remove(this.edges[edgeIndex]);
		this.edges.splice(edgeIndex, 1);

		this.remove(this.edgeLabels[edgeIndex]);
		this.edgeLabels.splice(edgeIndex, 1);
		this.coordinateLabels.splice(index, 1);

		this.remove(this.angleLabels[index]);
		this.angleLabels.splice(index, 1);

		this.spheres.splice(index, 1);

		this.update();

		this.dispatchEvent({ type: 'marker_removed', measurement: this });
	};

	setMarker(index, point) {
		this.points[index] = point;

		let event = {
			type: 'marker_moved',
			measure: this,
			index: index,
			position: point.position.clone()
		};
		this.dispatchEvent(event);

		this.update();
	}

	setPosition(index, position) {
		let point = this.points[index];
		point.position.copy(position);

		let event = {
			type: 'marker_moved',
			measure: this,
			index: index,
			position: position.clone()
		};
		this.dispatchEvent(event);

		this.update();
	};

	getArea() {
		let area = 0;
		let j = this.points.length - 1;

		for (let i = 0; i < this.points.length; i++) {
			let p1 = this.points[i].position;
			let p2 = this.points[j].position;
			area += (p2.x + p1.x) * (p1.y - p2.y);
			j = i;
		}

		return Math.abs(area / 2);
	};

	getTotalDistance() {
		if (this.points.length === 0) {
			return 0;
		}

		let distance = 0;

		for (let i = 1; i < this.points.length; i++) {
			let prev = this.points[i - 1].position;
			let curr = this.points[i].position;
			let d = prev.distanceTo(curr);

			distance += d;
		}

		if (this.closed && this.points.length > 1) {
			let first = this.points[0].position;
			let last = this.points[this.points.length - 1].position;
			let d = last.distanceTo(first);

			distance += d;
		}

		return distance;
	}

	getAngleBetweenLines(cornerPoint, point1, point2) {
		let v1 = new Vector3().subVectors(point1.position, cornerPoint.position);
		let v2 = new Vector3().subVectors(point2.position, cornerPoint.position);

		// avoid the error printed by threejs if denominator is 0
		const denominator = Math.sqrt(v1.lengthSq() * v2.lengthSq());
		if (denominator === 0) {
			return 0;
		} else {
			return v1.angleTo(v2);
		}
	};

	getAngle(index) {
		if (this.points.length < 3 || index >= this.points.length) {
			return 0;
		}

		let previous = (index === 0) ? this.points[this.points.length - 1] : this.points[index - 1];
		let point = this.points[index];
		let next = this.points[(index + 1) % (this.points.length)];

		return this.getAngleBetweenLines(point, previous, next);
	}

	// updateAzimuth(){
	// 	// if(this.points.length !== 2){
	// 	// 	return;
	// 	// }

	// 	// const azimuth = this.azimuth;

	// 	// const [p0, p1] = this.points;

	// 	// const r = p0.position.distanceTo(p1.position);

	// }

	update() {
		if (this.points.length === 0) {
			return;
		}

		// Obtener la cámara activa
		const camera = this.viewer.scene.getActiveCamera();

		// Define el umbral de distancia para ocultar elementos
		const visibilityThreshold = 20;

		if (this.points.length === 1) {
			let point = this.points[0];
			let position = point.position;

			const distance = camera.position.distanceTo(position);
			const isVisible = distance < visibilityThreshold;
			const scale = Math.max(10 / distance, 0.1);

			// Gestionar esfera
			let sphere = this.spheres[0];
			if (sphere) {
				sphere.position.copy(position);
				sphere.scale.set(scale, scale, scale);
				sphere.visible = isVisible;
			}

			// Gestionar etiqueta de coordenadas
			let coordinateLabel = this.coordinateLabels[0];
			if (coordinateLabel) {
				let msg = position.toArray().map((p) => Utils.addCommas(p.toFixed(2))).join(" / ");
				coordinateLabel.setText(msg);
				coordinateLabel.visible = this.showCoordinates && isVisible;
			}

			return;
		}

		let lastIndex = this.points.length - 1;

		let centroid = new Vector3();
		for (let i = 0; i <= lastIndex; i++) {
			let point = this.points[i];
			centroid.add(point.position);
		}
		centroid.divideScalar(this.points.length);

		for (let i = 0; i <= lastIndex; i++) {
			let index = i;
			let nextIndex = (i + 1 > lastIndex) ? 0 : i + 1;
			let previousIndex = (i === 0) ? lastIndex : i - 1;

			let point = this.points[index];
			let nextPoint = this.points[nextIndex];
			let previousPoint = this.points[previousIndex];

			let sphere = this.spheres[index];

			// Gestionar visibilidad y escala por distancia
			const distance = camera.position.distanceTo(sphere.getWorldPosition(new Vector3()));
			const isVisible = distance < visibilityThreshold;
			const scale = Math.max(10 / distance, 0.1);

			sphere.scale.set(scale, scale, scale);
			sphere.position.copy(point.position);
			sphere.material.color = this.color;
			sphere.visible = isVisible;

			{ // edges
				let edge = this.edges[index];

				if (edge) {
					edge.material.color = this.color;

					edge.position.copy(point.position);

					edge.geometry.setPositions([
						0, 0, 0,
						...nextPoint.position.clone().sub(point.position).toArray(),
					]);

					edge.geometry.verticesNeedUpdate = true;
					edge.geometry.computeBoundingSphere();
					edge.computeLineDistances();
					edge.visible = index < lastIndex || this.closed;
					if (!this.showEdges) {
						edge.visible = false;
					}
					edge.visible = isVisible;
				}
			}

			{ // edge labels
				let edgeLabel = this.edgeLabels[i];
				let center = new Vector3().add(point.position);
				center.add(nextPoint.position);
				center = center.multiplyScalar(0.5);
				let distanceBetweenPoints = point.position.distanceTo(nextPoint.position);

				edgeLabel.position.copy(center);

				let suffix = "";
				if (this.lengthUnit != null && this.lengthUnitDisplay != null) {
					distanceBetweenPoints = distanceBetweenPoints / this.lengthUnit.unitspermeter * this.lengthUnitDisplay.unitspermeter;  //convert to meters then to the display unit
					suffix = this.lengthUnitDisplay.code;
				}

				let txtLength = Utils.addCommas(distanceBetweenPoints.toFixed(2));
				edgeLabel.setText(`${txtLength} ${suffix}`);
				edgeLabel.visible = this.showDistances && (index < lastIndex || this.closed) && this.points.length >= 2 && distanceBetweenPoints > 0 && isVisible;
			}

			{ // angle labels
				let angleLabel = this.angleLabels[i];
				let angle = this.getAngleBetweenLines(point, previousPoint, nextPoint);

				let dir = nextPoint.position.clone().sub(previousPoint.position);
				dir.multiplyScalar(0.5);
				dir = previousPoint.position.clone().add(dir).sub(point.position).normalize();

				let dist = Math.min(point.position.distanceTo(previousPoint.position), point.position.distanceTo(nextPoint.position));
				dist = dist / 9;

				let labelPos = point.position.clone().add(dir.multiplyScalar(dist));
				angleLabel.position.copy(labelPos);

				let msg = Utils.addCommas((angle * (180.0 / Math.PI)).toFixed(1)) + '\u00B0';
				angleLabel.setText(msg);

				angleLabel.visible = this.showAngles && (index < lastIndex || this.closed) && this.points.length >= 3 && angle > 0 && isVisible;
			}
		}

		{ // update height stuff
			let heightEdge = this.heightEdge;
			heightEdge.visible = this.showHeight;

			if (this.showHeight) {
				let sorted = this.points.slice().sort((a, b) => a.position.z - b.position.z);
				let lowPoint = sorted[0].position.clone();
				let highPoint = sorted[sorted.length - 1].position.clone();
				let min = lowPoint.z;
				let max = highPoint.z;
				let height = max - min;

				let start = new Vector3(highPoint.x, highPoint.y, min);
				let end = new Vector3(highPoint.x, highPoint.y, max);

				heightEdge.position.copy(lowPoint);

				heightEdge.geometry.setPositions([
					0, 0, 0,
					...start.clone().sub(lowPoint).toArray(),
					...start.clone().sub(lowPoint).toArray(),
					...end.clone().sub(lowPoint).toArray(),
				]);

				heightEdge.geometry.verticesNeedUpdate = true;
				heightEdge.geometry.computeBoundingSphere();
				heightEdge.computeLineDistances();

				let heightLabelPosition = start.clone().add(end).multiplyScalar(0.5);
				this.heightLabel.position.copy(heightLabelPosition);

				const heightDistance = camera.position.distanceTo(heightEdge.position);
				const isHeightVisible = heightDistance < visibilityThreshold;
				this.heightLabel.visible = isHeightVisible;
				heightEdge.visible = isHeightVisible;

				let suffix = "";
				if (this.lengthUnit != null && this.lengthUnitDisplay != null) {
					height = height / this.lengthUnit.unitspermeter * this.lengthUnitDisplay.unitspermeter;  //convert to meters then to the display unit
					suffix = this.lengthUnitDisplay.code;
				}

				let txtHeight = Utils.addCommas(height.toFixed(2));
				let msg = `${txtHeight} ${suffix}`;
				this.heightLabel.setText(msg);
			}
		}

		{ // update area label
			this.areaLabel.position.copy(centroid);
			const areaDistance = camera.position.distanceTo(this.areaLabel.position);
			const isAreaVisible = areaDistance < visibilityThreshold;
			this.areaLabel.visible = this.showArea && this.points.length >= 3 && isAreaVisible;
			if (this.showArea && this.points.length >= 3) {
				let area = this.getArea();
				let suffix = "";
				if (this.lengthUnit != null && this.lengthUnitDisplay != null) {
					area = area / Math.pow(this.lengthUnit.unitspermeter, 2) * Math.pow(this.lengthUnitDisplay.unitspermeter, 2);  //convert to square meters then to the square display unit
					suffix = this.lengthUnitDisplay.code;
				}

				let txtArea = Utils.addCommas(area.toFixed(1));
				let msg = `${txtArea} ${suffix}\u00B2`;
				this.areaLabel.setText(msg);
			}
		}
	};

	raycast(raycaster, intersects) {
		for (let i = 0; i < this.points.length; i++) {
			let sphere = this.spheres[i];

			sphere.raycast(raycaster, intersects);
		}

		// recalculate distances because they are not necessarely correct
		// for scaled objects.
		// see https://github.com/mrdoob/three.js/issues/5827
		// TODO: remove this once the bug has been fixed
		for (let i = 0; i < intersects.length; i++) {
			let I = intersects[i];
			I.distance = raycaster.ray.origin.distanceTo(I.point);
		}
		intersects.sort(function (a, b) { return a.distance - b.distance; });
	};

	get showCoordinates() {
		return this._showCoordinates;
	}

	set showCoordinates(value) {
		this._showCoordinates = value;
		this.update();
	}

	get showAngles() {
		return this._showAngles;
	}

	set showAngles(value) {
		this._showAngles = value;
		this.update();
	}

	get showCircle() {
		return this._showCircle;
	}

	set showCircle(value) {
		this._showCircle = value;
		this.update();
	}

	get showAzimuth() {
		return this._showAzimuth;
	}

	set showAzimuth(value) {
		this._showAzimuth = value;
		this.update();
	}

	get showEdges() {
		return this._showEdges;
	}

	set showEdges(value) {
		this._showEdges = value;
		this.update();
	}

	get showHeight() {
		return this._showHeight;
	}

	set showHeight(value) {
		this._showHeight = value;
		this.update();
	}

	get showArea() {
		return this._showArea;
	}

	set showArea(value) {
		this._showArea = value;
		this.update();
	}

	get closed() {
		return this._closed;
	}

	set closed(value) {
		this._closed = value;
		this.update();
	}

	get showDistances() {
		return this._showDistances;
	}

	set showDistances(value) {
		this._showDistances = value;
		this.update();
	}

}